import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.startLoading = this.startLoading.bind(this)
    this.restoreButton = this.restoreButton.bind(this)
    this.element.addEventListener('turbo:submit-start', this.startLoading)
    this.element.addEventListener('turbo:submit-end', this.restoreButton)
  }

  disconnect() {
    this.element.removeEventListener('turbo:submit-start', this.startLoading)
    this.element.removeEventListener('turbo:submit-end', this.restoreButton)
  }

  // INTENT: Apply Web Awesome native loading state when Turbo starts form submission.
  // EXPECTED OUTCOME: Button displays native Web Awesome loading spinner only AFTER HTML5/Web Component validation passes.
  // CAVEAT/TRAP: turbo:submit-start fires only after form validation succeeds, eliminating manual reportValidity() checks.
  startLoading() {
    const form = this.element
    const submitButton = form.querySelector('wa-button[type="submit"]') ||
      (form.id ? document.querySelector(`wa-button[form="${form.id}"]`) : null)

    if (!submitButton) return

    submitButton.loading = true
    submitButton.setAttribute('loading', '')
  }

  restoreButton() {
    const form = this.element
    const submitButton = form.querySelector('wa-button[type="submit"]') ||
      (form.id ? document.querySelector(`wa-button[form="${form.id}"]`) : null)

    if (!submitButton) return

    submitButton.loading = false
    submitButton.removeAttribute('loading')
    submitButton.disabled = false
    submitButton.removeAttribute('disabled')
  }
}
